import { TranslateService } from "@ngx-translate/core";
import { AppConfig } from "../../appconfig";
import { take } from "rxjs";

export class Languages {
  public readonly availableLanguages: string[];
  private readonly defaultLangIdx: number;
  private currentLangIdx = -1;

  constructor(
    private config: AppConfig,
    private translate: TranslateService) {
    this.availableLanguages = ["en", "de", "fr"];
    this.defaultLangIdx = this.getLanguageIdx(config.defaultLanguage());
  }

  /**
   * gets the number of the currently selected language
   */
  public getSelectedlanguage() {
    return this.currentLangIdx;
  }

  /**
   * gets the iso name of the currently selected language
   */
  public getSelectedlanguageISO() {
    return this.availableLanguages[this.currentLangIdx];
  }


  /**
   * selects the new language and applies it
   * @param index theme number
   */
  public setSelectedlanguage(index: number) {
    this.changeLanguage(index);
  }

  /**
   * selects the new language and applies it
   * @param name language
   */
  public setSelectedlanguageByName(name: string) {
    if (name == null || name == "") {
      return;
    }
    name = name.toLowerCase();
    const idx = this.availableLanguages.indexOf(name);
    if (idx >= 0) {
      this.changeLanguage(idx);
    }
  }


  private getLanguageIdx(lang: string): number {
    let idx = this.availableLanguages.indexOf(lang);
    if (idx < 0) {
      idx = 0;
    }
    return idx;
  }

  /**
   * applies the previous selected language
   */
  public applyLanguage() {
    if (this.currentLangIdx >= 0 && this.currentLangIdx < this.availableLanguages.length) {
      this.changeLanguage(this.currentLangIdx);
    } else {
      this.changeLanguage(this.defaultLangIdx);
    }
  }

  public changeLanguage(index: number) {
    this.translate.use(this.availableLanguages[index]).pipe(take(1)).subscribe();
    this.currentLangIdx = index;
  }
}
